import { AspectRatio, Box, HStack, SimpleGrid, Text } from '@chakra-ui/react'

import Image from 'next/image'

const PercentRatingItem = ({
  title,
  percent,
  src
}: {
  title: string
  percent: string
  src: any
}) => {
  return (
    <Box>
      <HStack w="100%" justifyContent="center">
        <Box w={600} display="flex" justifyContent="space-between">
          <Text textStyle="docPercentTitle" textAlign="left">
            {title}
          </Text>
          <Text
            textTransform="uppercase"
            textStyle="docMainTitle"
            textAlign="left"
          >
            {percent}
          </Text>
        </Box>
      </HStack>

      <Box display="flex" justifyContent="center">
        <AspectRatio w={600} ratio={600 / 16} position="relative">
          <Image src={src} alt={title} fill />
        </AspectRatio>
      </Box>
    </Box>
  )
}

const PercentRating = () => {
  return (
    <SimpleGrid
      columns={1}
      gap={{
        base: 4,
        md: 10
      }}
      mt={20}
      data-aos="fade-up"
    >
      <PercentRatingItem
        title="Skin moisture satisfaction"
        percent="95%"
        src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/ninety-five-percent-1710996636647.png"
      />
      <PercentRatingItem
        title="Skin application & finish"
        percent="90%"
        src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/ninety-percent-1710996636649.png"
      />
      <PercentRatingItem
        title="Skin elasticity improvement"
        percent="90%"
        src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/ninety-percent-1710996636649.png"
      />
      <PercentRatingItem
        title="Makeup does not flake after use"
        percent="95%"
        src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/ninety-five-percent-1710996636647.png"
      />
      <PercentRatingItem
        title="Skin becomes moist and dewy"
        percent="90%"
        src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/ninety-percent-1710996636649.png"
      />
      <PercentRatingItem
        title="Willing to purchase again?"
        percent="90%"
        src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/ninety-percent-1710996636649.png"
      />
    </SimpleGrid>
  )
}

export default PercentRating
